/** Statut affiché sur la home / bibliothèque (pastilles New / Ongoing / Completed). */
export type HomeProcessDisplayStatus = 'new' | 'ongoing' | 'completed';

/**
 * « Terminé » uniquement lorsque toutes les interviews sont finalisées (completed_at),
 * pas lorsque la seule cartographie a été générée ou forcée.
 * @param allInterviewsCompleted `null` = chargement en cours → on n’affiche pas « terminé ».
 */
export function computeHomeProcessDisplayStatus(
    hasNotif: boolean,
    allInterviewsCompleted: boolean | null
): HomeProcessDisplayStatus {
    if (hasNotif) return 'new';
    if (allInterviewsCompleted === true) return 'completed';
    return 'ongoing';
}
